import Vue from 'vue'

export default {

    getConversations(projectid,params=''){  
                
        /*
        Get a list of conversations.
        Available filters: search, type (all, mine, bot, manual)
        Available sort: created_at, updated_at
        */
        
        return new Promise((resolve, reject) =>{
            Vue.prototype.$apiService.get("projects/" + projectid + "/conversations" + Vue.prototype.$apiService.getSerializedQuery(params)).then((res)=>{                              
                resolve(res);
            })
        })    
    },
    
    acquireControl(conversation){
        return new Promise((resolve, reject) =>{
            Vue.prototype.$apiService.post("conversations/" +conversation+ "/control").then((res)=>{                              
                resolve(res);
            })
        })    
    },

    relesControl(conversation){
        return new Promise((resolve, reject) =>{
            Vue.prototype.$apiService.delete("conversations/" +conversation+ "/control").then((res)=>{                              
                resolve(res);
            })
        })    
    },

    getConversation(conversationid){

        return new Promise((resolve, reject) =>{
            Vue.prototype.$apiService.get("conversations/" + conversationid ).then((res)=>{                              
                resolve(res);
            })
        }) 

    }
    
    
}